import { error, ok, url } from '@datacamp/exercise-library-utils';
import fetch from 'cross-fetch';
import { z } from 'zod';
import { getEndpoints } from '../lib/endpoints';
const GroupNode = z.object({
  aiCoursesExercisesEnabled: z.boolean(),
  aiErrorExplanationEnabled: z.boolean(),
  aiSolutionExplanationEnabled: z.boolean(),
  groupType: z.enum(['academic', 'b2c2b', 'enterprise']),
  id: z.number(),
  name: z.string(),
  status: z.enum(['activated', 'cancelled', 'created', 'expired', 'pending_activation', 'set_for_cancellation'])
});
const GroupsByUserResponse = z.object({
  groupsByUser: z.object({
    edges: z.array(z.object({
      node: GroupNode
    }))
  })
});
export class GroupHubApiClient {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }
  async getUserGroupSettings(_ref) {
    let {
      userId
    } = _ref;
    try {
      const response = await fetch(url(this.endpoint, 'graphql'), {
        body: JSON.stringify({
          query: "\n          query($user_id: Int!) {\n            groupsByUser(userId: $user_id) {\n              edges {\n                node {\n                  id\n                  aiErrorExplanationEnabled\n                  aiSolutionExplanationEnabled\n                  aiCoursesExercisesEnabled\n                  status\n                  name\n                  groupType\n                }\n              }\n            }\n          }",
          variables: {
            user_id: userId
          }
        }),
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
      const body = await response.json();
      if (!response.ok) {
        return error(new Error("getUserGroupSettings status ".concat(response.status)));
      }
      const parsedBody = GroupsByUserResponse.safeParse(body.data);
      if (!parsedBody.success) {
        return error(parsedBody.error);
      }
      return ok(parsedBody.data.groupsByUser.edges.map(edge => edge.node));
    } catch (err) {
      return error(err);
    }
  }
}
export const groupHubApiClient = environment => new GroupHubApiClient(getEndpoints(environment).GROUP_HUB_API);